module.exports = "<img src=\"./assets/<%= data.Image %>\">\n\n<div class=\"title\"><%= data.Title %></div>\n\n<div class=\"text\"><%= data.Text %></div>"